import { useEffect, useState } from "react";
import { textInnerStyle } from "../lib/elementStyle";
import { isEn } from "../i18n";

// Renders a text element bound to a Google Sheet cell/range.
export function SheetText({ el, values }) {
  const s = el.estilo || {};
  const mode = el.sheetBind?.mode || "cell";
  const [i, setI] = useState(0);
  useEffect(() => {
    if (mode !== "rotate" || !values || values.length < 2) return;
    const ms = Math.max(1, el.sheetBind?.intervalo || 5) * 1000;
    const id = setInterval(() => setI((x) => x + 1), ms);
    return () => clearInterval(id);
  }, [mode, values, el.sheetBind?.intervalo]);

  let text;
  if (!values || !values.length) text = el.conteudo || "";
  else if (mode === "stack") text = values.slice(0, el.sheetBind?.maxLinhas || 5).join("\n");
  else if (mode === "rotate") text = values[i % values.length];
  else text = values[0];

  return <div style={textInnerStyle(s)} data-testid="sheet-text">{text}</div>;
}

// Renders an image element whose source URL comes from a Google Sheet cell/range.
// Accepts a direct http(s) URL or an =IMAGE("url") formula string.
const extractImgUrl = (v) => {
  if (!v) return null;
  const s = String(v).trim();
  const m = s.match(/=\s*IMAGE\(\s*["']([^"']+)["']/i);
  if (m) return m[1].trim();
  if (/^https?:\/\//i.test(s)) return s;
  return null;
};

export function SheetImage({ el, values, editor = false }) {
  const mode = el.sheetBind?.mode || "cell";
  const [i, setI] = useState(0);
  useEffect(() => {
    if (mode !== "rotate" || !values || values.length < 2) return;
    const ms = Math.max(1, el.sheetBind?.intervalo || 5) * 1000;
    const id = setInterval(() => setI((x) => x + 1), ms);
    return () => clearInterval(id);
  }, [mode, values, el.sheetBind?.intervalo]);

  const raw = values && values.length ? values[mode === "rotate" ? i % values.length : 0] : null;
  const src = extractImgUrl(raw);
  if (!src) {
    if (editor && el.sheetBind?.enabled) {
      return (
        <div data-testid="sheet-image-empty" style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center", border: "1px dashed rgba(148,163,184,0.5)", borderRadius: 6, background: "rgba(148,163,184,0.08)", padding: 8, textAlign: "center", boxSizing: "border-box" }}>
          <span style={{ fontSize: 10.5, lineHeight: 1.35, color: "#94a3b8" }}>{isEn() ? <>Empty Sheets image. In a public sheet, paste the direct <b>URL</b> as plain text in the cell. <b>=IMAGE("url")</b> is only read when your Google account is connected.<br />"Insert image in cell" can't be read by the Google API.</> : <>Imagem do Sheets vazia. Em planilha pública, cole a <b>URL</b> direta como texto na célula. <b>=IMAGE("url")</b> só é lido com a conta Google conectada.<br />"Inserir imagem na célula" não é lido pela API do Google.</>}</span>
        </div>
      );
    }
    return null;
  }
  return <img src={src} alt="" style={{ width: "100%", height: "100%", objectFit: "contain", pointerEvents: "none" }} data-testid="sheet-image" />;
}
